import { useCallback, useState } from 'react';

import type { AiAssistantMode } from './types';
import { ElevenLabsTranscriptionConfig } from './transcription/ElevenLabsTranscriptionConfig';
import { useTranscriptionConfig, UseTranscriptionConfigResult } from './transcription/useTranscriptionConfig';
import { useAiAssistantProviderGlobalState } from './shared/useAiAssistantProviderGlobalState';

export type UseAiAssistantPanelResult = {
   mode: AiAssistantMode;
   setMode: (mode: AiAssistantMode) => void;
   config: UseTranscriptionConfigResult;
   elevenlabsConfig: {
      dictationConfig: ElevenLabsTranscriptionConfig;
      continuousConfig: ElevenLabsTranscriptionConfig;
      setDictationConfig: (config: ElevenLabsTranscriptionConfig) => void;
      setContinuousConfig: (config: ElevenLabsTranscriptionConfig) => void;
   };
};

export const useAiAssistantPanel = (): UseAiAssistantPanelResult => {
   const [mode, setMode] = useState<AiAssistantMode>('DICTATION');
   const config = useTranscriptionConfig();

   const {
      dictationConfig: globalDictationConfig,
      continuousConfig: globalContinuousConfig,
      setDictationConfig: setGlobalDictationConfig,
      setContinuousConfig: setGlobalContinuousConfig,
   } = useAiAssistantProviderGlobalState();

   const setDictationConfig = useCallback(
      (config: ElevenLabsTranscriptionConfig) => {
         setGlobalDictationConfig(config);
      },
      [setGlobalDictationConfig]
   );

   const setContinuousConfig = useCallback(
      (config: ElevenLabsTranscriptionConfig) => {
         setGlobalContinuousConfig(config);
      },
      [setGlobalContinuousConfig]
   );

   return {
      mode: mode,
      setMode: setMode,
      config: config,
      elevenlabsConfig: {
         dictationConfig: globalDictationConfig,
         continuousConfig: globalContinuousConfig,
         setDictationConfig: setDictationConfig,
         setContinuousConfig: setContinuousConfig,
      },
   };
};
